import * as z from "zod";

export const verifyOrCreateNotOnSaleCollection = {
  name: "verifyOrCreateNotOnSaleCollection" as const,
  input: z.null(),
  output: z.string(),
};
